import { Shield, Lock, RefreshCw, Globe } from "lucide-react";
import { useTranslation } from "../../../i18n";

export default function SecurityPractices() {
  const { t } = useTranslation();
  const practices = [
    {
      icon: <Lock className="h-6 w-6" />,
      title: t('routes.identity.security.items.0.title'),
      description: t('routes.identity.security.items.0.description'),
      color: "from-red-500 to-pink-600",
    },
    {
      icon: <RefreshCw className="h-6 w-6" />,
      title: t('routes.identity.security.items.1.title'),
      description: t('routes.identity.security.items.1.description'),
      color: "from-emerald-500 to-teal-600",
    },
    {
      icon: <Shield className="h-6 w-6" />,
      title: t('routes.identity.security.items.2.title'),
      description: t('routes.identity.security.items.2.description'),
      color: "from-blue-500 to-indigo-600",
    },
    {
      icon: <Globe className="h-6 w-6" />,
      title: t('routes.identity.security.items.3.title'),
      description: t('routes.identity.security.items.3.description'),
      color: "from-purple-500 to-indigo-600",
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center mb-4">
            <div className="h-12 w-12 rounded-xl bg-gradient-to-br from-red-500 to-red-600 flex items-center justify-center mr-4">
              <Shield className="h-7 w-7 text-white" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
              {t('routes.identity.security.title')}
            </h2>
          </div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('routes.identity.security.description')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          {practices.map((practice, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-white to-gray-50 rounded-2xl p-6 border border-gray-200 hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
            >
              <div className="flex items-start">
                <div
                  className={`h-12 w-12 rounded-lg bg-gradient-to-br ${practice.color} flex items-center justify-center mr-4 text-white flex-shrink-0`}
                >
                  {practice.icon}
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    {practice.title}
                  </h3>
                  <p className="text-gray-600">{practice.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Security Compliance Badge */}
        <div className="bg-gradient-to-br from-slate-50 to-blue-50 rounded-3xl p-10 text-center border border-slate-200 shadow-lg">
          <div className="flex items-center justify-center mb-6">
            <div className="h-16 w-16 rounded-2xl bg-gradient-to-br from-emerald-500 to-teal-600 shadow-lg flex items-center justify-center mr-4">
              <Shield className="h-8 w-8 text-white" />
            </div>
            <div className="text-left">
              <h3 className="text-2xl font-bold text-gray-900">
                {t('routes.identity.security.badgeTitle')}
              </h3>
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
            <div className="p-4">
              <div className="text-2xl font-bold text-emerald-600">99.9%</div>
              <div className="text-sm text-gray-600">
                {t('routes.identity.security.uptime')}
              </div>
            </div>
            <div className="p-4">
              <div className="text-2xl font-bold text-blue-600">5 min</div>
              <div className="text-sm text-gray-600">
                {t('routes.identity.security.tokenLifetime')}
              </div>
            </div>
            <div className="p-4">
              <div className="text-2xl font-bold text-purple-600">
                bcrypt 12
              </div>
              <div className="text-sm text-gray-600">
                {t('routes.identity.security.hashRounds')}
              </div>
            </div>
            <div className="p-4">
              <div className="text-2xl font-bold text-indigo-600">24/7</div>
              <div className="text-sm text-gray-600">
                {t('routes.identity.security.monitoring')}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
